import type {
  IAfterVisitSummaryController,
  IAfterVisitSummaryService,
} from "../../core/ports/AfterVisitSummary";

export const AfterVisitSummaryControllerFactory = ({
  afterVisitSummaryService,
}: {
  afterVisitSummaryService: IAfterVisitSummaryService;
}): IAfterVisitSummaryController => ({
  startAfterVisitSummary: afterVisitSummaryService.startAfterVisitSummary,
  getAfterVisitSummary: afterVisitSummaryService.getAfterVisitSummary,
  editAfterVisitSummary: afterVisitSummaryService.editAfterVisitSummary,
  downloadAfterVisitSummaryPdf:
    afterVisitSummaryService.downloadAfterVisitSummaryPdf,
  getHchbCoordinationNoteTypes:
    afterVisitSummaryService.getHchbCoordinationNoteTypes,
  sendAfterVisitSummary: afterVisitSummaryService.sendAfterVisitSummary,
  retryCoordinationNote: afterVisitSummaryService.retryCoordinationNote,
});
